import BayLogo from '../../BayLogo';
import type { BooleanCallback } from '../../types/callbacks';
import type { TranslationFunction } from '../../types/common';
import { LaunchpadButtonWrapper } from '../styles/navStyles';

import LaunchpadButton from './LaunchpadButton';

interface DesktopBrandingProps {
	t?: TranslationFunction;
	/** Render the Back At You wordmark before the Launchpad button */
	showBrandLogo?: boolean;
	showLaunchpadButton?: boolean;
	/** Disables the Launchpad button and shows its upgrade prompt */
	showLaunchpadUpgradeButton?: boolean;
	platformType?: string;
	showLaunchpadModal?: boolean;
	setShowLaunchpadModal?: BooleanCallback;
	setIsDrawerOpen?: BooleanCallback;
}

// The start of the bar at ≥768px: the opt-in wordmark, then the Launchpad
// button. Below 768px this is hidden and TopNav renders the Launchpad button in
// the action nav instead.
const DesktopBranding = ({
	t,
	showBrandLogo = false,
	showLaunchpadButton = false,
	showLaunchpadUpgradeButton = false,
	platformType,
	showLaunchpadModal,
	setShowLaunchpadModal,
	setIsDrawerOpen,
}: DesktopBrandingProps) => (
	<LaunchpadButtonWrapper className={`launchpad-btn-spacing d-none ${showBrandLogo ? 'd-md-flex align-items-center' : 'd-md-block'} me-auto`}>
		{showBrandLogo && (
			<span className="bay-nav-brand d-inline-flex me-3">
				<BayLogo logoStyle="wordmark" size="28px" alt="Back At You" />
			</span>
		)}
		{showLaunchpadButton && (
			<LaunchpadButton
				disabled={showLaunchpadUpgradeButton}
				platformType={platformType}
				setIsDrawerOpen={setIsDrawerOpen}
				setShowLaunchpadModal={setShowLaunchpadModal}
				showLaunchpadModal={showLaunchpadModal}
				t={t}
			/>
		)}
	</LaunchpadButtonWrapper>
);

export default DesktopBranding;
